function updateItem(id, quantity){
    loader_on();
    var data = {
        'id'       : id,
        'quantity' : quantity
    }

    jQuery.post('/wp-admin/admin-ajax.php', {
        action: 'update_cart_product',
        data: data
    },
        function (res) {
            loader_off();
            cart_widget();
        }
    );
}

function startMasks(){

    var check = $('.phone-mask').length;   

    if ( check > 0 ) {

        var items = document.getElementsByClassName('phone-mask');

        Array.prototype.forEach.call(items, function (element) {
            var phoneMask = new IMask(element, {
                mask: '+{7} (000) 000-00-00',
                lazy: false,  // make placeholder always visible
                placeholderChar: '_'     // defaults to '_'
            });
        });


    }
    
    var check = $('.quantity-mask').length;    
    
    if ( check > 0 ) {
        
        var items = document.getElementsByClassName('quantity-mask');        

        Array.prototype.forEach.call(items, function (element) {            
            var min = element.getAttribute('data-min');

            if(!min) {
                min = 0;
            }         
            
            element.oninput = function() {
                var elem = $(this),
                    val  = elem.val();

                if(val == '' || val < min){
                    elem.val(min);
                }
            }; 
                
            var sumMask = new IMask(element, {
                mask: Number,
                min: min,
                max: 50,
                thousandsSeparator: '',
                radix: '.'
            });

        });

    }

    var check = $('.number-mask').length;    
    
    if ( check > 0 ) {

        var items = document.getElementsByClassName('number-mask');

        Array.prototype.forEach.call(items, function (element) {
            var sumMask = new IMask(element, {
                mask: Number,
                min: 0,
                max: 1000000,
                thousandsSeparator: '',
                radix: '.'
            });
        });

    }

    $(document).on('input', '.name-mask', function(){
        var elem = $(this),
            val  = elem.val().replace(/[^А-Яа-я-\s]/gi, ''),
            val  = val.substr(0, 24);        

        elem.val(val);
    });

    $(document).on('input', '.quantity-mask', function(){
        var elem = $(this),
            min  = elem.data('min'),
            val  = elem.val();
        
        if(!min){
            min = 0;
        }

        if(val < min && val > 50 || val != ''){
            elem.val(min);
            val = min;
        }

        if(elem.hasClass('cart-quantity-input')){
            var item  = elem.parents('.table-item'),
                price = item.find('.price span').text(),
                total = item.find('.total span');

            total.text(price * val);  
        }

    })

    $(document).on('change', '.quantity-mask', function(){
        var elem = $(this),
            min  = elem.data('min'),
            item = elem.parents('.table-item'),
            id   = item.data('id'),
            val  = elem.val();

        if(!min){
            min = 0;
        }

        if(val < min && val > 50 || val == ''){
            elem.val(min);
            val = min;
        }

        if(elem.hasClass('cart-quantity-input')){
            updateItem(id, val);
        }        
        
    })

}

$(document).ready(function () {
    startMasks();
});